import ReactDOM from "react-dom/client";
import { App } from "./App.tsx";
import "./index.css";
import "@total-typescript/ts-reset";
import { fetchInitialGlobalContext } from "./utils/GlobalContext.ts";
import { injectCjkFontPreloads } from "./utils/injectCjkFontPreloads.ts";
import { initI18n } from "./services/i18n";

injectCjkFontPreloads();

(async () => {
  const app = await (async () => {
    try {
      const globalContext = await fetchInitialGlobalContext();
      injectCjkFontPreloads(globalContext.locale);
      // Initialize i18n before rendering so useTranslation() never suspends
      // on first mount (idempotent; App.tsx still handles locale switches).
      await initI18n(globalContext.locale);
      return <App globalContext={globalContext} />;
    } catch (e) {
      console.error(e);
      return <p>Error</p>;
    }
  })();

  ReactDOM.createRoot(document.getElementById("root")!).render(app);
})();
